import axios from "axios";

let BASE_URL = "/api/nb";

// In development mode, use the current host instead of hardcoded localhost
if (import.meta.env.MODE === "development") {
	// Get the current host from the browser's location
	const currentHost = window.location.hostname;
	const apiPort = 5875; // Your API port
	BASE_URL = `http://${currentHost}:${apiPort}/api/nb`;
}

export default axios.create({
	baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
	baseURL: BASE_URL,
	headers: { "Content-Type": "application/json" },
	withCredentials: true,
});